import { render, staticRenderFns } from "./SectionShopNewly.vue?vue&type=template&id=08d153b3&scoped=true&lang=pug&"
import script from "./SectionShopNewly.vue?vue&type=script&lang=js&"
export * from "./SectionShopNewly.vue?vue&type=script&lang=js&"
import style0 from "./SectionShopNewly.vue?vue&type=style&index=0&id=08d153b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d153b3",
  null
  
)

export default component.exports